import { ERROR_CODES } from './ErrorCodes'
import { GenericException, GenericExceptionError } from './GenericException'

export class RequestInvalidException extends GenericException {
  constructor(error?: GenericExceptionError) {
    super({
      ...ERROR_CODES.REQUEST_INVALID,
      ...(error || {}),
    })
  }
}
